import {
  ADMIN_SELF_BID_CREATE_ERROR,
  DUPLICATE_PREFERENCE_ALERT_MESSAGE,
  EMPLOYEE_ID_REQUIRED,
  INVALID_EMPLOYEE_ID,
} from "../util/messageConstants";
import { CHOICE_ORDER } from "../util/constants";
export function hasDuplicateChoices(choices) {
  const allChoices = Object.values(choices);
  const uniqueChoices = new Set(allChoices);

  return allChoices.length !== uniqueChoices.size;
}

export function allChoicesSelected(choices) {
  return Object.values(choices).every((choice) => !!choice);
}

export const isDuplicatePreference = (permanentBid, currentPreference) => {
  return permanentBid.some(
    (tableDataRow) =>
      tableDataRow !== currentPreference &&
      tableDataRow.daysOff === currentPreference.daysOff &&
      tableDataRow.position === currentPreference.position &&
      tableDataRow.startTime === currentPreference.startTime
  );
};

export function validatePreferences(preferences) {
  const validatedPreferences = preferences.map((preference) => {
    const isDuplicate = isDuplicatePreference(preferences, preference);
    if (isDuplicate) {
      preference.message = DUPLICATE_PREFERENCE_ALERT_MESSAGE;
    } else {
      preference.message = "";
    }

    return preference;
  });

  return validatedPreferences;
}

export function areDuplicatePreferencesExists(preferences) {
  return preferences.some((preference) => preference.message);
}

export const choiceErrorsInitialState = {
  earliestAM: "",
  latestAM: "",
  earliestPM: "",
  latestPM: "",
};

export const choicesInitialState = {
  earliestAM: "",
  latestAM: "",
  earliestPM: "",
  latestPM: "",
};

export function formatHolidayChoices(holidayChoice) {
  const choiceArray = Object.entries(holidayChoice).map(([key, value]) => ({ key, choice: value }));
  const sortedChoices = choiceArray.sort((a, b) => {
    return CHOICE_ORDER[a.choice] - CHOICE_ORDER[b.choice];
  });
  return sortedChoices.map((choice) => choice.key);
}

export function validateChoices(allChoices) {
  const seenValues = {};
  const result = {};

  for (const key in allChoices) {
    const value = allChoices[key];
    if (value === "") {
      result[key] = "Required";
    }
    // If value is already in seenValues, it's a duplicate for this key
    else if (seenValues[value]) {
      result[key] = "Duplicate";
      result[seenValues[value]] = "Duplicate"; // Mark the previous key as duplicate too
    } else {
      seenValues[value] = key; // Store the key for this value
      result[key] = "";
    }
  }
  return result;
}

export function validatePermanentBidEmployeeId(input, userId) {
  if (input.trim() === "") {
    return EMPLOYEE_ID_REQUIRED;
  } else if (input.trim().charAt(0).toUpperCase() !== "E") {
    return INVALID_EMPLOYEE_ID + ' - start with "e"';
  } else if (!input.match("e\\d{0,6}$")) {
    return INVALID_EMPLOYEE_ID;
  } else if (userId === input) {
    return ADMIN_SELF_BID_CREATE_ERROR;
  }
  return "";
}

export function validateEmployeeDataForAdminPermanentBid(input, selectedStation) {
  if (input === null) {
    return "Not loaded";
  }

  if (!input.isActive) {
    return INVALID_EMPLOYEE_ID;
  }
  if (input.activeStation !== selectedStation && input.homeStation !== selectedStation) {
    return "Employee must work in " + selectedStation;
  }
  if (input?.tempStation === selectedStation && input.homeStation !== selectedStation) {
    return "Cannot create Permanent Bid for incoming temps";
  }
  return "";
}
